import {Paper, Stack, Text} from '@mantine/core'

import {formatBusinessTimestamp} from 'src/api/business-time'

import type {EquipmentLocationEvent} from './schemas'

type EquipmentDeploymentHistorySectionProps = {
    events: EquipmentLocationEvent[]
}

function formatEventType(eventType: EquipmentLocationEvent['eventType']) {
    switch (eventType) {
        case 'picked_up':
            return 'Picked up'
        case 'deployed':
            return 'Deployed'
        case 'returned':
            return 'Returned'
        case 'dispatched':
            return 'Dispatched'
    }
}

function formatEventTimestamp(timestamp: string) {
    return formatBusinessTimestamp(timestamp, 'MMM d, yyyy · h:mm a')
}

export function EquipmentDeploymentHistorySection({
    events,
}: EquipmentDeploymentHistorySectionProps) {
    return (
        <Paper withBorder p="md" radius="md">
            <Text fw={600} mb="xs">
                Deployment history
            </Text>
            {events.length === 0 ? (
                <Text size="sm" c="dimmed">
                    No deployment history yet.
                </Text>
            ) : (
                <Stack gap="sm">
                    {events.map((event) => (
                        <Stack key={event.id} gap={2}>
                            <Text size="sm" fw={600}>
                                {formatEventType(event.eventType)} · {event.locationLabel}
                            </Text>
                            <Text size="xs" c="dimmed">
                                {formatEventTimestamp(event.timestamp)} · {event.projectName}
                            </Text>
                        </Stack>
                    ))}
                </Stack>
            )}
        </Paper>
    )
}
